module.exports = __webpack_public_path__ + "img/banner_new.564bb691.png";